import { render } from "./ClientTable.vue?vue&type=template&id=1c848e12"
import script from "./ClientTable.vue?vue&type=script&lang=js"
export * from "./ClientTable.vue?vue&type=script&lang=js"

import "./ClientTable.vue?vue&type=style&index=0&id=1c848e12&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__